/* eslint-disable header/header */
export const name = "@azure/msal-react";
export const version = "1.5.3";
